import templateUrl from "emun.invoice/invoice-list.htm";
import controller from "emun.invoice/invoice-list.controller";

export default {
  bindings: {
    customer: "<",
    customerId: "@",
    orderId: "@",
    invoiceRef: "@",
    mode: "@"
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
